import React from 'react'
import Form from '../components/Form'

function MainHeader() {


    return (
        <div>
        <div className="mainheader">
        <h1>Synonym Generator</h1>
        <Form />

        <small><a href='https://www.freepik.com/vectors/school'>School vector created by pch.vector - www.freepik.com</a></small>

            
        </div>
        </div>
    )
}

export default MainHeader
